"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class RawAggregateData extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.objectTypeName = 'rawAggregateData';
        this._records = (0, util_1.camelArray)(initParams.records);
        this._time = initParams.time;
        this._value = initParams.value;
    }
    set records(value) {
        console.error('Do not set objects this way');
    }
    get records() {
        return this._records;
    }
    set time(value) {
        console.error('Do not set objects this way');
    }
    get time() {
        return this._time;
    }
    set value(value) {
        console.error('Do not set objects this way');
    }
    get value() {
        return this._value;
    }
}
exports.default = RawAggregateData;
//# sourceMappingURL=rawAggregateData.js.map